export enum ERoutes {
  EMPTY = '',
  SLASH = '/',
  UNKNOWN = '**',
  HOME_VIEW_TAG = 'home-view',
  TRIP_PLANNER = 'trip-planner',
  TRIP_POPULAR_ITINERARIES = 'trip-popular-itineraries',
  TOP_ITINERARIES = 'top-itineraries',
  ABOUT_US = 'about-us',
  WIDGETS = 'widgets',
  POPULAR_ITINERARIES_WIDGET = 'popular-itineraries',
  TRIP_TESTIMONIALS = 'trip-testimonials',
  PRIVACY_POLICY = 'privacy-policy',
  TERMS_N_CONDITIONS = 'terms-n-conditions',
  ACCESSIBILITY_DECLARATION = 'accessibility-declaration',
  ACCOUNT = 'account',
  CAR_RENTAL = 'car-rental',
  MY_TRIPS = 'my-wish-list',
  SAVED_TRIPS = 'saved-trips',
  SETTINGS = 'settings',
  COUNTRIES = 'countries',
  AI_CHAT = 'ai-chat',
  BOOKING = 'booking',
  ERROR = 'error',
  OVERVIEW = 'overview',
  DAY_BY_DAY = 'day-by-day',
}
